import { Alert, Button, Link, Stack, Typography } from '@mui/material';
import { FileAttachment04 } from 'untitledui-js-base';
import { formatPrice } from '../../utils/formatPrice';
import { BasicDialog } from '../common/BasicDialog';
import { SourceNameCell } from './SourceNameCell';
import { SourceCommissionPreviewResult } from './type/sourceCommissions';
import { getPaymentTypeLabel } from './utils';

interface PreviewDialogProps {
  open: boolean;
  result?: SourceCommissionPreviewResult;
  onClose: () => void;
}

/** Náhled je dočasný (BE ho po cca hodině smaže), nic se neukládá. */
export const PreviewDialog = ({ open, result, onClose }: PreviewDialogProps) => (
  <BasicDialog open={open} onClose={onClose} title="Náhled dokladů" fullWidth maxWidth="sm">
    <Stack gap={2}>
      <Alert severity="info">
        Jde o náhled. Nic nebylo vystaveno ani vyplaceno. PDF je dočasné a po zhruba hodině zmizí.
      </Alert>
      {result?.failed.length ? (
        <Alert severity="warning">Pro tyto POJ se náhled nepodařilo vytvořit: {result.failed.join(', ')}.</Alert>
      ) : null}
      {result?.documents.length ? (
        result.documents.map((doc, idx) => (
          <Stack key={`${doc.sourceId}-${idx}`} direction="row" justifyContent="space-between" gap={2}>
            <Stack>
              <SourceNameCell name={doc.sourceName} tradeName={doc.sourceTradeName} />
              <Typography variant="body2" color="text.secondary">
                POJ: {doc.itemsCount} · {formatPrice(doc.totalPrice, 2)} · {getPaymentTypeLabel(doc.paymentType)}
              </Typography>
            </Stack>
            {doc.pdf ? (
              <Link href={doc.pdf} target="_blank" rel="noopener" underline="always">
                <Stack direction="row" alignItems="center" gap={0.5}>
                  <FileAttachment04 size="14px" /> Otevřít náhled
                </Stack>
              </Link>
            ) : (
              <Typography variant="body2" color="text.secondary">
                PDF není k dispozici
              </Typography>
            )}
          </Stack>
        ))
      ) : (
        <Typography>Žádný doklad by nevznikl.</Typography>
      )}
      <Button onClick={onClose} variant="contained">
        Zavřít
      </Button>
    </Stack>
  </BasicDialog>
);
